import { cn } from "@becon-team/becon-fe-lib/my-tailwind-css";
import { ReactNode } from "react";

import type { PropsWithCC } from "@becon-team/becon-fe-lib/my-types";
export interface InquiryFormLayoutProps {
  number: string;
  label: ReactNode;
  info?: string;
  isRequired?: boolean;
  errorMessage?: string;
}
export const InquiryFormLayout = ({
  children,
  className,
  number,
  label,
  info,
  isRequired = false,
  errorMessage,
}: PropsWithCC<InquiryFormLayoutProps>) => {
  return (
    <div className={cn("relative", className)}>
      <div className="flex-start flex">
        <div className="text-xl font-bold">{`${number}.`}</div>
        {isRequired && <div className="text-xl font-medium text-red">*</div>}
      </div>
      <div className="text-xl font-light">{label}</div>
      {info && <div className="text-base-600 text-md">{info}</div>}
      <div className="mt-sp-16">{children}</div>
      <div className="mt-sp-6 text-xs text-red">{errorMessage}</div>
    </div>
  );
};
